import React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useAppSelector } from "../../../../app/hooks";
import { selectSettings } from "../../../settings/settingsSlice";

export const MeetingMinutesReportsDropdown = ({ meetingMinuteId }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const { locale } = useAppSelector(selectSettings);

    const baseUrl = process.env.REACT_APP_REST_API;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (reportType) => {
        setAnchorEl(null);
        if (!meetingMinuteId || !locale) return;

        let url;

        switch (reportType) {
            case "FULL":
                url = `${baseUrl}api/reports/meeting-minutes/general/${meetingMinuteId}?language=${locale}`;
                break;
            case "ACTIVE":
                url = `${baseUrl}api/reports/meeting-minutes/onlyactive/${meetingMinuteId}?language=${locale}`;
                break;
            case "ACTIVE_NOHISTORY":
                url = `${baseUrl}api/reports/meeting-minutes/minimal/${meetingMinuteId}?language=${locale}`;
                break;
            case "FULL_NO_HISTORY":
                url = `${baseUrl}api/reports/meeting-minutes/nohistory/${meetingMinuteId}?language=${locale}`;
                break;
            case "MEETING":
                url = `${baseUrl}api/reports/meeting-minutes/meeting/${meetingMinuteId}?language=${locale}`;
                break;
            default:
                url = null;
                break;
        }

        if (url) {
            window.open(url, "_blank");
        }
    };


    return (
        <div>
            <Button
                variant="contained"
                endIcon={<ArrowDropDownIcon />}
                onClick={handleClick}
            >
                Wybierz raport
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem onClick={() => handleMenuItemClick("MEETING")}>
                    Spotkanie
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClick("FULL")}>
                    Pełny raport
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClick("FULL_NO_HISTORY")}>
                    Wszystko bez historii
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClick("ACTIVE_FULLHISTORY")}>
                    Aktywne z pełną historią
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClick("ACTIVE_NOHISTORY")}>
                    Aktywne bez historii (minimalny raport)
                </MenuItem>
            </Menu>
        </div>
    );
};